import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatorModule } from '~app/common/modules/translator/translator.module';
import { MaterialModule } from '../material/material.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatorModule, MaterialModule],
    exports: [FormsModule, ReactiveFormsModule, TranslatorModule, MaterialModule, CommonModule],
    providers: [],
})
export class DependencyModule {}
